import { Formik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { userAgeProps } from './user-age.props';
import { hoc } from 'src/core/utils';
import { months, years } from './user-age.data';

const validationSchema = Yup.object().shape({
  month: Yup.string().required("Обов'язкове поле"),
  year: Yup.string().required("Обов'язкове поле")
});

/**
 * <User age />
 */

const UserAge = hoc(userAgeProps, ({ verified, warning, getAgeGate }) => {
  return (
    <div className='main_container'>
      {!verified && (
        <div className='age_page'>
          <div className='container age_container'>
            <div className='agegate_logo' />
            {warning ? (
              <div className='first_page_text'>
                Для отримання доступу до інформації, що містить вебсайт, Вам
                повинно виповнитись 18 або більше.
              </div>
            ) : (
              <>
                <div className='first_page_text'>
                  Тобі більш ніж 18 років, ти куриш чи використовуєш інші
                  продукти з нікотином? Сорі за особисте питання, але коли твій
                  день народження? Нам достатньо знати місяць і рік.
                </div>
                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    month: '',
                    year: ''
                  }}
                  enableReinitialize
                  onSubmit={(values, { setSubmitting }) => {
                    getAgeGate(values);
                    setSubmitting(false);
                  }}
                >
                  {formProps => {
                    const {
                      handleSubmit,
                      setFieldValue,
                      errors,
                      touched
                    } = formProps;
                    return (
                      <div>
                        <div className='form_container'>
                          <div>
                            <Select
                              className='react-select-container'
                              classNamePrefix='react-select'
                              placeholder='Місяць*'
                              onChange={option =>
                                setFieldValue('month', option.value)
                              }
                              options={months}
                              isSearchable={false}
                            />
                            {errors.month && touched.month && (
                              <div className='fieldError'>{errors.month}</div>
                            )}
                          </div>
                          <div>
                            <Select
                              className='react-select-container'
                              classNamePrefix='react-select'
                              placeholder='Рік*'
                              name='year'
                              options={years}
                              onChange={option =>
                                setFieldValue('year', option.value)
                              }
                              isSearchable={false}
                            />
                            {errors.year && touched.year && (
                              <div className='fieldError'>{errors.year}</div>
                            )}
                          </div>

                          <button
                            // type='submit'
                            className='age_submit-button turq-hover btn'
                            onClick={() => handleSubmit()}
                          >
                            Підтвердити
                          </button>
                        </div>
                      </div>
                    );
                  }}
                </Formik>
              </>
            )}
            <div className='legaldocs-des'>
              <span>
                Натискаючи «Підтвердити» ти також надаєш згоду на отримання
                інформації про продукцію, що представлена на сайті, за допомогою
                засобів дистанційного зв'язку згідно з ч. 2 ст. 15 Закону
                України «Про захист прав споживачів». <br />
                <br />
                <br />
                <p style={{ marginBottom: 'unset' }}>
                  <strong>Ми про все подбаємо. </strong>
                </p>
                На сайті розміщена інфо про бездимні продукти, призначені для
                повнолітніх, які так чи інакше продовжили б курити або вживати
                інші продукти з нікотином в Україні. Бездимні продукти PMI не є
                альтернативою відмови від куріння та не створені для допомоги у
                цьому.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export { UserAge };
